module.exports = __webpack_public_path__ + "static/media/ogImageSmall.6e4dabe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/Meta/ogImageSmall.jpg
// module id = 279
// module chunks = 0 1 2 4 5 6 7 8